<template>
  <div v-if="load">
    <scale-loader/>
  </div>
  <div v-else-if="profile == null">
    <div class="wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center">
              <h2 class="title text-danger">
                SimCardProfile: {{cur_id}} not found
              </h2>
              <router-link :to="{path:'/simcard_profile_list'}">
                To List SimCardProfile
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <tabs parent="simcard_profile" v-else>
    <tab id="profile" :name="translate('simcard_profile.section.profile')" :href="url+'/profile'" >
      <Profile :id="cur_id" :profile="profile" ref="profile" @update="get_simcard"/>
    </tab>

    <tab id="traffic" :name="translate('simcard_profile.section.traffic')" :href="url+'/traffic'" :is-visible="imsi">
      <Traffic :sim_id="imsi" />
    </tab>

    <tab id="tariff_history" :name="translate('simcard_profile.section.tariff_history')" :href="url+'/tariff_history'">
      <Tariff :sim_id="cur_id" />
    </tab>

    <tab id="actions" v-if="this.$store.getters.getPermissions?.controlSimcardProfile === true" :name="translate('simcard_profile.section.actions')" :href="url+'/actions'">
      <Actions :sim_id="imsi" :profile="profile"/>
    </tab>

  </tabs>
</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Profile from './Tabs/Profile/Index.vue'
import Tariff from './Tabs/Tariff/Tariff.vue'
import Actions from './Tabs/Actions/Index.vue'
import Traffic from "./Tabs/Traffic/Index.vue";

export default {
  name: 'SimCardProfile',
  components: {
    Traffic,
    Profile,
    Tariff,
    Actions,
    Tab,
    Tabs,
  },
  data () {
    return {
      pred_id: false,
      section: 'profile',
      interval: null,
      simcard: {},
      change: false
    }
  },

  beforeRouteLeave(to, from, next) {
    this.ProveSaveOnLeave(next)
  },

  beforeRouteUpdate(to, from, next) {
    this.ProveSaveOnLeave(next)
  },

  computed: {
    url () { return '/simcard_profile/' + this.$route.params.simcard_profile_id },
    cur_id () { return this.$route.params.simcard_profile_id },
    imsi () { return this.simcard.profile.imsi },
    profile () { return this.simcard.profile },
    load () {
      if (this.simcard) {
        return this.simcard.load === undefined || this.simcard.load
      }
      return true
    }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'simcard_profile_section') {
        this.request_simcard()
      } else {
        clearInterval(this.interval)
      }
    },
    $route () {
      if (this.$route.params.simcard_profile_section === 'profile') {
        this.request_simcard()
      }
    },
    load () {
      clearInterval(this.interval)
      if(this.load === false && this.simcard.profile !== null) {
        if (this.cur_id){
          this.interval = setInterval(() => {
            this.$store.dispatch('updateSimcardProfileProfile', this.cur_id)
          }, this.$store.getters.getSimcardDevicesProfileUpdate)
        }
      }
    }
  },

  activated(){
    this.request_simcard()

    this.interval = setInterval(() => {
      this.request_simcard()
    }, this.$store.getters.getSimcardProfileProfileUpdate)
  },

  deactivated () {
    clearInterval(this.interval)
  },

  destroyed () {
    clearInterval(this.interval)
  },
  methods: {
    OnChange (value) {
      this.change = value
    },
    ProveSaveOnLeave (next) {
      next()
    },
    request_simcard () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_simcard, 500)
    },

    get_simcard () {
      if (this.cur_id) {
        this.$store.dispatch('updateSimcardProfileProfile', this.cur_id)
        this.simcard = this.$store.getters.getSimcardProfileById(this.cur_id)
      }
    }
  }
}

</script>
